// modules
import LocaleService from 'modules/Localization';
import { THEME_KEYS } from 'modules/TradingChart/consts';
// typings
import { TimeFrameItem } from '../sources/charting_library.min';
// consts
import customCssBlobUrl from '../customCss';

function getBaseWidgetOptions(params: IBaseWidgetParamsProps) {
  const { digitsAfterDot, theme } = params;

  return {
    container: 'tv_chart_container',
    library_path: '/charting_library/static/',
    timezone: 'Asia/Kolkata',
    locale: 'en',
    toolbar_bg: 'transparent',
    fullscreen: false,
    autosize: true,
    countdown: true,
    widgetbar: {
      details: true,
      news: false,
      watchlist: true,
      datawindow: true,
    },
    studies_overrides: {
      // list of all indicators:
      // 'accumulation/distribution',
      // 'accumulative swing index',
      // 'advance/decline',
      'arnaud legoux moving average.precision': digitsAfterDot,
      'aroon.precision': digitsAfterDot,
      // 'average directional index',
      'average price.precision': digitsAfterDot,
      'average true range.precision': digitsAfterDot,
      'awesome Oscillator.precision': digitsAfterDot,
      // 'balance of power',
      'bollinger bands.precision': digitsAfterDot,
      // 'bollinger bands %b',
      'bollinger bands width.precision': digitsAfterDot,
      // 'chaikin money flow',
      // 'chaikin oscillator',
      // 'chaikin volatility',
      'chande kroll stop.precision': digitsAfterDot,
      // 'chande momentum oscillator',
      // 'chop zone',
      'choppiness index.precision': digitsAfterDot,
      'commodity channel index.precision': digitsAfterDot,
      'connors rsi.precision': digitsAfterDot,
      // 'coppock curve',
      // 'correlation - log',
      // 'correlation coefficient',
      'detrended price oscillator.precision': digitsAfterDot,
      'directional movement.precision': digitsAfterDot,
      'donchian channels.precision': digitsAfterDot,
      'double ema.precision': digitsAfterDot,
      'ema cross.precision': digitsAfterDot,
      // 'ease of movement',
      // 'elder\'s force index',
      'envelopes.precision': digitsAfterDot,
      // 'fisher transform',
      // 'historical volatility',
      'hull moving average.precision': digitsAfterDot,
      'ichimoku cloud.precision': digitsAfterDot,
      'keltner channels.precision': digitsAfterDot,
      // 'klinger oscillator',
      // 'know sure thing',
      'least squares moving average.precision': digitsAfterDot,
      'linear regression curve.precision': digitsAfterDot,
      'linear regression slope.precision': digitsAfterDot,
      'ma cross.precision': digitsAfterDot,
      'ma with ema cross.precision': digitsAfterDot,
      'macd.precision': digitsAfterDot,
      // 'majority rule',
      // 'mass index',
      'mcginley dynamic.precision': digitsAfterDot,
      'median price.precision': digitsAfterDot,
      'momentum.precision': digitsAfterDot,
      'money flow index.precision': digitsAfterDot,
      'moving average.precision': digitsAfterDot,
      'moving average adaptive.precision': digitsAfterDot,
      'moving average channel.precision': digitsAfterDot,
      'moving average double.precision': digitsAfterDot,
      'moving average exponential.precision': digitsAfterDot,
      'moving average hamming.precision': digitsAfterDot,
      'moving average modified.precision': digitsAfterDot,
      'moving average multiple.precision': digitsAfterDot,
      'moving average triple.precision': digitsAfterDot,
      'moving average weighted.precision': digitsAfterDot,
      // 'net volume',
      // 'on balance volume',
      'parabolic sar.precision': digitsAfterDot,
      // 'pivot points standard',
      'price channel.precision': digitsAfterDot,
      'price oscillator.precision': digitsAfterDot,
      // 'price volume trend',
      'rate of change.precision': digitsAfterDot,
      // 'ratio.precision',
      'relative strength index.precision': digitsAfterDot,
      // 'relative vigor index',
      'relative volatility index.precision': digitsAfterDot,
      // 'smi ergodic indicator/oscillator',
      'smoothed moving average.precision': digitsAfterDot,
      // 'spread',
      // 'standard deviation',
      // 'standard error',
      // 'standard error bands',
      'stochastic.precision': digitsAfterDot,
      'stochastic rsi.precision': digitsAfterDot,
      'supertrend.precision': digitsAfterDot,
      'trix.precision': digitsAfterDot,
      // 'trend strength index',
      'triple ema.precision': digitsAfterDot,
      // 'true strength indicator',
      'typical price.precision': digitsAfterDot,
      'ultimate oscillator.precision': digitsAfterDot,
      'vwap.precision': digitsAfterDot,
      'vwma.precision': digitsAfterDot,
      // 'volatility close-to-close',
      // 'volatility index',
      // 'volatility 0-h-l-c',
      // 'volatility zero trend close-to-close',
      // 'volume.volume.color.0': '#DB542A',
      // 'volume.volume.color.1': '#148564',
      // 'volume oscillator',
      // 'vortex indicator',
      'williams %r.precision': digitsAfterDot,
      'williams alligator.precision': digitsAfterDot,
      'williams fractal.precision': digitsAfterDot,
      // 'zig zag',
    },
    overrides: {
      // Countdown to bar close
      'mainSeriesProperties.showCountdown': true,
      'timeScale.countdown': true,
      // Show Volume in OHLCV legend
      'paneProperties.legendProperties.showVolume': true,
      'Moving Average Adaptive.precision': 2,
    },
    custom_css_url: customCssBlobUrl,
    custom_translate_function: (key: string) => {
      switch (key) {
        case 'Time in force':
          return LocaleService.translate('VALIDITY');

        case 'Lots':
          return LocaleService.translate('QUANTITY');

        case 'Last':
          return LocaleService.translate('LTP');

        case 'Specified amount is not a multiple of the instrument quantity step of {step}.':
          return LocaleService.translate(
            'ORDER_PANEL_MUTILPLE_OF_QUANTITY_ERROR_MESSAGE',
          );

        case 'Number format is invalid.':
          return LocaleService.translate('QUANTITY_INPUT_ERROR_MESSAGE');

        case 'Account Manager':
            return LocaleService.translate('DASHBOARD');
        default:
          return null;
      }
    },
    time_frames: [
      {
        text: '5Y',
        resolution: '1W',
        description: '5 Years',
        title: '5Y',
      },
      {
        text: '1Y',
        resolution: '1W',
        description: '1 Year',
        title: '1Y',
      },
      {
        text: '6M',
        resolution: '120',
        description: '6 Months',
        title: '6M',
      },
      {
        text: '3M',
        resolution: '60',
        description: '3 Months',
        title: '3M',
      },
      {
        text: '1M',
        resolution: '30',
        description: '1 Month',
        title: '1M',
      },
      {
        text: '5D',
        resolution: '5',
        description: '5 Days',
        title: '5D',
      },
      {
        text: '1D',
        resolution: '1',
        description: '1 Day',
        title: '1D',
      },
    ] as TimeFrameItem[],
    auto_save_delay: 5,
    broker_config: {
      configFlags: {
        supportBottomWidget: true,
        supportNativeReversePosition: true,
        supportClosePosition: true,
        supportPLUpdate: true,
        supportLevel2Data: true,
        showQuantityInsteadOfAmount: true,
        supportOrderBrackets: false,
        supportStopLimitOrders: true,
        supportPlaceOrderPreview: false,
        supportModifyOrderPreview: false,
        supportStopOrders: true,
        supportMarketOrders: true,
        supportLimitOrders: true,
        supportModifyOrder: true,
        showNotificationsLog: false,
        supportPositions: true,
        supportReversePosition: false,
      },
    },
    theme: THEME_KEYS[theme],
  } as const;
}

export default getBaseWidgetOptions;
